import Vue from 'vue'
import Vuex from 'vuex'
import ProductApiRequest from '@/store/catalog/productApiRequest'
import Notifications from '@/store/notifications/notifications'

Vue.use(Vuex)

export interface ProductDetailsInterface {
  id: string,
  availability: string,
  price: number,
  title: string,
  categories: string[],
  link: string,
  imageUrl: string,
  images: string[],
}

export interface ProductDetailsStatusInterface {
  productDetails: ProductDetailsInterface
  loading: boolean,
  catalogId: string,
  productId: string,
  imagesDetails: any,
}

export default new Vuex.Store({
  state: (): ProductDetailsStatusInterface => ({
    productDetails: {
      id: '',
      availability: 'in-stock',
      price: -1,
      title: '',
      categories: [],
      link: '',
      imageUrl: '',
      images: [],
    },
    imagesDetails: {},
    loading: false,
    catalogId: '',
    productId: '',
  }),
  mutations: {
    setCatalogId: (state: any, catalogId: string) => {
      state.catalogId = catalogId
    },
    setProductId: (state: any, productId: string) => {
      state.productId = productId
    },
    setDetails: (state: any, details: any) => {
      state.productDetails = details
    },
    setLoading: (state: any, loading: boolean) => {
      state.loading = loading
    },
    setImagesDetails: (state: any, imagesDetails: any) => {
      state.imagesDetails = imagesDetails
    },
  },
  actions: {
    getProductDetails(context: any) {
      context.commit('setLoading', true)
      ProductApiRequest.getProductVariants(
        {
          catalogId: context.state.catalogId,
          productId: context.state.productId,
        },
      ).then(result => {
        if (result.status === 200) {
          context.commit('setDetails', result.data)

          ProductApiRequest.getAllImagesDetails(
            {
              catalogId: context.state.catalogId,
              productId: context.state.productId,
            },
          ).then(imageDetailsResult => {
            context.commit('setImagesDetails', imageDetailsResult.data)
          }).catch(error => {
            Notifications.commit('addError', error, { root: true })
          })
        }
        context.commit('setLoading', false)
        return result
      }).catch(error => {
        Notifications.commit('addError', error, { root: true })
        context.commit('setLoading', false)
      })
    },
  },
})
